<template>
  <b-form>
    <b-card class="border0 py0 mt30" body-class="grpHd device">
      <b-row>
        <b-col class="col-6">
          <label>디바이스 타입</label>
          <b-form-select
            :options="devicetypeOptions"
            v-model="devicetype"
            disabled
          ></b-form-select>
        </b-col>
        <b-col class="col-6">
          <label>디바이스 ID</label>
          <b-form-input v-model="deviceid" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6" v-if="channel !== null && channel !== undefined">
          <label>CH#</label>
          <b-form-input v-model="channel" disabled></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>설치 일자</label>
          <b-form-input type="date" v-model="instldate" disabled></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="border0 py0 my30" body-class="grpHd sensor">
      <b-row>
        <b-col class="col-6">
          <label>센서 종류</label>
          <b-form-select
            :options="sensortypeOptions"
            v-model="sensortype"
            disabled
          ></b-form-select>
        </b-col>
        <b-col class="col-6">
          <label>센서 모델</label>
          <b-form-select
            :options="sensormodelOptions"
            v-model="sensormodel"
            disabled
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>센서 이름</label>
          <b-form-input
            v-model="sensoralias"
            trim
            pattern=".{1,128}"
            title="최대 128자 이하로 입력해주세요"
            disabled
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>시리얼 번호</label>
          <b-form-input
            v-model="sn"
            trim
            pattern=".{1,64}"
            title="최대 64자 이하로 입력해주세요"
            disabled
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>MAC 주소</label>
          <b-form-input v-model="mac" disabled></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>매칭 시리얼 번호</label>
          <b-form-input
            v-model="macsn"
            trim
            pattern=".{1,64}"
            title="최대 64자 이하로 입력해주세요"
            disabled
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12">
          <label>설치 장소</label>
          <b-form-input v-model="instlloc" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12">
          <label>설치 상세 위치</label>
          <b-form-input
            v-model="instldesc"
            trim
            pattern=".{1,128}"
            title="최대 128자 이하로 입력해주세요"
            disabled
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>설치 상태</label>
          <b-form-select
            :options="instlstateOptions"
            v-model="instlstate"
            disabled
          ></b-form-select>
        </b-col>
        <b-col class="col-6">
          <label>관리 여부</label>
          <b-form-select
            :options="manageynOptions"
            v-model="manageyn"
            disabled
          ></b-form-select>
        </b-col>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <!-- <b-button v-if="sensorInfo.regiYn" class="addBtn" type="submit"><i class="fa fa-check-circle"></i>등록</b-button>
        <b-button v-else class="chgBtn" type="submit"><i class="fa fa-edit"></i>변경</b-button> -->
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["getAlertOptions", "getConfirmOptions"]),
  },
  props: {
    defaultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      devicetype: null,
      devicetypeOptions: [{ value: null, text: "선택" }],
      deviceid: null,
      channel: null,
      instldate: null,
      sensortype: null,
      sensortypeOptions: [{ value: null, text: "선택" }],
      sensormodel: null,
      sensormodelOptions: [{ value: null, text: "선택" }],
      sensoralias: null,
      sn: null,
      mac: null,
      macsn: null,
      instlloc: null,
      instldesc: null,
      instlstate: null,
      instlstateOptions: [{ value: null, text: "선택" }],
      manageyn: null,
      manageynOptions: [{ value: null, text: "선택" }],
    };
  },
  created() {
    this.getDefaultCodes();
  },
  beforeMount() {},
  mounted() {
    this.getSensorDetailInfo();
  },
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    getDefaultCodes() {
      var reqBody = {
        codegrp: "devicetype,sensortype,instlstate,manageyn",
      };
      this.$http
        .post("/comn/code", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var codeGrp = reqBody.codegrp.split(",");
            for (let i = 0; i < codeGrp.length; i++) {
              let value = [{ value: null, text: "선택" }];
              let codeVal = res.data[codeGrp[i]];
              for (let j = 0; j < codeVal.length; j++) {
                value.push({
                  value: codeVal[j].cd,
                  text: codeVal[j].nm,
                });
              }
              this[codeGrp[i] + "Options"] = value;
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorDetailInfo() {
      var reqBody = {
        deviceid: this.defaultInfo.deviceid,
        channel: this.defaultInfo.channel,
        sensortype: this.defaultInfo.sensortype,
      };
      this.$http
        .post("/sensor/getSensorDetailInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var sensorInfo = res.data.data;
            this.devicetype = this.defaultInfo.devicetype;
            this.deviceid = this.defaultInfo.deviceid;
            this.channel = this.defaultInfo.channel;
            this.sensortype = this.defaultInfo.sensortype;
            this.instldate = sensorInfo.instldate;
            this.getSensorModel(this.sensortype).then((res) => {
              this.sensormodel = sensorInfo.sensormodelidx;
            });
            this.sensoralias = sensorInfo.sensoralias;
            this.sn = sensorInfo.sn;
            this.macsn = sensorInfo.macsn;
            this.mac = sensorInfo.mac;
            this.instlloc = sensorInfo.instlloc;
            this.instldesc = sensorInfo.instldesc;
            this.instlstate = sensorInfo.instlstate;
            this.manageyn = sensorInfo.manageyn;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getSensorModel(type) {
      var reqBody = {
        sensortype: type,
      };
      await this.$http
        .post("/sensor/getSensorCatalog", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var cataloglist = res.data.data;
            var options = [{ value: null, text: "선택" }];
            for (let i = 0; i < cataloglist.length; i++) {
              options.push({
                value: cataloglist[i].idx,
                text: cataloglist[i].sensormodel,
              });
            }
            this.sensormodelOptions = options;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("sensorDetailModal");
    },
  },
};
</script>

<style lang="scss">
#sensorDetailModal .modal-dialog {
  max-width: 760px;
  & .modal-content {
    & .card {
      & .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;
        & .row .col {
          &:first-child {
            padding-right: 10px;
          }
          &:last-child {
            padding-left: 10px;
          }
          &:only-child {
            padding-left: 0;
            padding-right: 0;
            &:not(.col-12) {
              padding-right: 10px;
            }
          }
          & label {
            display: flex;
            align-items: center;
            height: 100%;
            padding-bottom: 1px;
          }
          & input,
          & select {
            width: calc(100% - 130px);
          }
        }
        &.grpHd {
          &::before {
            display: block;
            position: absolute;
            top: -15px;
            left: 50px;
            font-size: 15px;
            font-weight: 600;
            border: 1px solid #7367f0;
            color: #b4b7bd;
            background: #283046;
            padding: 2px 10px 4px;
            letter-spacing: 1px;
          }
          &.device::before {
            content: "디바이스 정보";
          }
          &.sensor::before {
            content: "센서 정보";
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorDetailModal.vue